import React from 'react'
import ProjectTemplate from '../../Projects/ProjectTemplate/ProjectTemplate'
import CheetSheetTemplate from '../CheetSheet/CheetSheetTemplate'
import Python1 from '../../../media/Python-1.png'
import Python2 from '../../../media/Python-2.png'
import Python3 from '../../../media/Python-3.png'
export default function Python(props) {

    return (
        <>
            <ProjectTemplate name='Python CheetSheet' mode={props.mode} isValue={props.isValue} >
                <div className="aboutMe blogDiv">
                    <CheetSheetTemplate
                        headerStyle='none'
                        des={`Python is a powerful and popular programming language that is widely used in many fields, including web development, data analysis, and scientific computing. It is known for its simplicity and readability, making it a great language for beginners to learn.`}

                        headStyle='none'
                        imgCss='largeImage'
                        img={Python1}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        headerStyle='none'
                        des={`In this blog post, we'll go over some basic Python concepts and provide examples to help you get started.`}

                        headStyle='none'
                    />
                    {/* <CheetSheetTemplate
                        headerStyle='none'
                        headStyle='none'
                        class='none'
                        img='https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.pngall.com%2Fwp-content%2Fuploads%2F5%2FPython-PNG-Pic.png&f=1&nofb=1&ipt=a486cb02fc40c9b501810a696df4bac6efd3ee4983795fe6ac461475dd09e736&ipo=images'
                    /> */}
                    <CheetSheetTemplate
                        headerStyle='none'
                        heading="Variables"
                        des='In Python, a variable is a storage location for a value. You can think of a variable as a box that holds a value. To create a variable in Python, you simply give it a name and assign it a value using the assignment operator (=).'
                        img={Python2}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='for example:'
                        code={`x = 5\ny = 10\nz = "hello"`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='In this code, we have created three variables: x, y, and z. x is assigned the value 5, y is assigned the value 10, and z is assigned the string "hello".'
                        code={`x = 5\ny = 10\nz = "hello"`}
                        headStyle='none'
                        headerStyle='none'

                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='You can also assign a value to a variable and then change it later. For example:'
                        code={`x = 5\nprint(x)  # Outputs 5\nx = 10\nprint(x)  # Outputs 10`}
                        headStyle='none'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='In Python, every value has a data type. Some common data types in Python include:'
                        heading='Data Types'
                        headerStyle='none'
                    />
                    {/* <CheetSheetTemplate
                        headerStyle='none'
                        headStyle='none'
                        class='none'
                        img='https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fmycstutorial.in%2Fwp-content%2Fuploads%2F2021%2F05%2Fdata_types-1536x519.png&f=1&nofb=1&ipt=f30092ef38401892596ce9def648e29b26d723ae1d7a10e4ae42a29cef462d6a&ipo=images'
                    /> */}
                    <CheetSheetTemplate
                        imgClass='none'
                        des='* int: Integer values (e.g. 1, 2, 3)'
                        headStyle='none'
                        headerStyle='none'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='* float: Floating point values (e.g. 1.0, 2.5, 3.14)'
                        headStyle='none'
                        headerStyle='none'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='* str: String values (e.g. "hello", "world")'
                        headStyle='none'
                        headerStyle='none'
                    />
                    <CheetSheetTemplate
                        des='* bool: Boolean values (True or False)'
                        headStyle='none'
                        headerStyle='none'
                        img={Python3}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='You can check the data type of a value using the type() function. For example:'
                        headStyle='none'
                        code={`x = 5\nprint(type(x))  # Outputs <class 'int'>\n\ny = "hello"\nprint(type(y))  # Outputs <class 'str'>\n\nz = True\nprint(type(z))  # Outputs <class 'bool'>`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='In Python, a list is an ordered collection of values that can be of any data type. Lists are defined using square brackets [ ] and the values are separated by commas.'
                        heading='List'
                        headerStyle='none'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='For example:'
                        headStyle='none'
                        code={`my_list = [1, 2, 3, 4, 5]\nprint(my_list)  # Outputs [1, 2, 3, 4, 5]\n\nmy_list = ["hello", "world"]\nprint(my_list)  # Outputs ["hello", "world"]\n\nmy_list = [1, 2.5, "hello"]\nprint(my_list)  # Outputs [1, 2.5, "hello"]`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='You can access the values in a list using their index. The index is the position of the value in the list, starting at 0 for the first value.'
                        headStyle='none'
                        headerStyle='none'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='For example:'
                        headStyle='none'
                        code={`my_list = ["apple", "banana", "cherry"]\nprint(my_list[0])  # Outputs "apple"\nprint(my_list[1])  # Outputs "banana"\nprint(my_list[2])  # Outputs "cherry"`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='You can also use negative indices to access values from the end of the list. For example:'
                        headStyle='none'
                        code={`my_list = ["apple", "banana", "cherry"]\nprint(my_list[-1])  # Outputs "cherry"\nprint(my_list[-2])  # Outputs "banana"\nprint(my_list[-3])  # Outputs "apple"`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='You can also use slicing to get a sublist of a list. Slicing is done using the start:end syntax, where start is the index of the first value to include and end is the index of the first value to exclude. For example:'
                        headStyle='none'
                        code={`my_list = [1, 2, 3, 4, 5]\nprint(my_list[1:3])  # Outputs [2, 3]\n\nmy_list = ["apple", "banana", "cherry", "date"]\nprint(my_list[1:3])  # Outputs ["banana", "cherry"]`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='You can also use negative indices with slicing. For example:'
                        headStyle='none'
                        code={`my_list = [1, 2, 3, 4, 5]\nprint(my_list[-3:-1])  # Outputs [3, 4]\n\nmy_list = ["apple", "banana", "cherry", "date"]\nprint(my_list[-3:-1])  # Outputs ["cherry", "date"]`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        heading='Dictionaries'
                        des='In Python, a dictionary is a collection of key-value pairs. Dictionaries are defined using curly braces { } and the key-value pairs are separated by commas. The keys and values can be of any data type.'
                        headerStyle='none'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='For example:'
                        headStyle='none'
                        code={`my_dict = {\n"name": "John",\n"age": 30,\n"city": "New York"\n}\nprint(my_dict)  # Outputs {'name': 'John', 'age': 30, 'city': 'New York'}`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='You can access the values in a dictionary using the keys. For example:'
                        headStyle='none'
                        code={`my_dict = {\n"name": "John",\n"age": 30,\n"city": "New York"\n}\nprint(my_dict["name"])  # Outputs "John"\nprint(my_dict["age"])  # Outputs 30\nprint(my_dict["city"])  # Outputs "New York"`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='You can also add new key-value pairs to a dictionary or modify existing ones. For example:'
                        headStyle='none'
                        code={`my_dict = {\n"name": "John",\n"age": 30,\n"city": "New York"\n}\nmy_dict["country"] = "United States"\nprint(my_dict)  # Outputs {'name': 'John', 'age': 30, 'city': 'New York', 'country': 'United States'}\n\nmy_dict["age"] = 35\nprint(my_dict)  # Outputs {'name': 'John', 'age': 35, 'city': 'New York', 'country': 'United States'}`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        heading='Loops'
                        des='In Python, you can use loops to repeat a block of code multiple times. There are two types of loops in Python: for loops and while loops.'
                        headerStyle='none'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        heading='For Loops'
                        des='A for loop is used to iterate over a sequence (such as a list or a string). The syntax for a for loop is:'
                        code={`for variable in sequence:\n\t# code to be executed`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='For example:'
                        headStyle='none'
                        code={`fruits = ["apple", "banana", "cherry"]\nfor fruit in fruits:\n\tprint(fruit)`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='This code will output the following:'
                        headStyle='none'
                        code={`apple\nbanana\ncherry`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='You can also use the range() function to specify the number of times to execute the loop. The range() function returns a sequence of numbers, starting from 0 by default, and increments by 1 (also by default), and ends at a specified number.'
                        headStyle='none'
                        headerStyle='none'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='For example:'
                        headStyle='none'
                        code={`for i in range(5):\n\tprint(i)`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='This code will output the following:'
                        headStyle='none'
                        code={`0\n1\n2\n3\n4`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        heading='While Loops'
                        des='A while loop is used to execute a block of code as long as a certain condition is true. The syntax for a while loop is:'
                        code={`while condition:\n\t# code to be executed`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='For example:'
                        headStyle='none'
                        code={`i = 0\nwhile i < 5:\n\tprint(i)\n\ti += 1`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='This code will output the following:'
                        headStyle='none'
                        code={`0\n1\n2\n3\n4`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        heading='Functions'
                        des='In Python, a function is a block of code that can be reusable and can be called by a name. Functions help you to organize your code and make it more modular.'
                        headerStyle='none'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='To define a function in Python, you use the def keyword followed by the function name and a pair of parentheses (). You can also specify parameters inside the parentheses. The block of code inside the function is indented.'
                        headerStyle='none'
                        headStyle='none'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='For example:'
                        headStyle='none'
                        code={`def greet(name):\n\tprint("Hello, " + name + "!")\n\ngreet("John")  # Outputs "Hello, John!"\ngreet("Mary")  # Outputs "Hello, Mary!"`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='You can also specify a default value for a parameter. If no value is passed for the parameter, the default value will be used.'
                        headerStyle='none'
                        headStyle='none'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='For example:'
                        headStyle='none'
                        code={`def greet(name="world"):\n\tprint("Hello, " + name + "!")\n\ngreet()  # Outputs "Hello, world!"\ngreet("John")  # Outputs "Hello, John!"`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='You can also specify a return value for a function using the return statement. The function will stop executing and return the specified value.'
                        headerStyle='none'
                        headStyle='none'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='For example:'
                        headStyle='none'
                        code={`def add(x, y):\n\treturn x + y\n\nresult = add(3, 4)\nprint(result)  # Outputs 7`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des={`That's it for this basic Python tutorial! I hope these examples have helped you get started with Python programming. There are many more concepts to learn, but these basics will give you a good foundation`}
                        headerStyle='none'
                        headStyle='none'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        heading='Object-Oriented Programming'
                        des='Object-oriented programming (OOP) is a programming paradigm that is based on the concept of "objects", which can contain data and code that manipulates that data. OOP allows you to create complex programs by organizing your code into "classes", which are templates for creating objects.'
                        headerStyle='none'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des={`In Python, you can define a class using the class keyword, followed by the class name and a pair of parentheses. The block of code inside the class is indented.`}
                        headerStyle='none'
                        headStyle='none'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='For example:'
                        headStyle='none'
                        code={`class Dog:\n\tdef __init__(self, name, breed):\n\t\tself.name = name\n\t\tself.breed = breed\n\ndog1 = Dog("Fido", "Labrador")\ndog2 = Dog("Buddy", "Poodle")\n\nprint(dog1.name)  # Outputs "Fido"\nprint(dog2.breed)  # Outputs "Poodle"`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des={`In this example, we have defined a Dog class with two attributes: name and breed. The __init__ method is a special method in Python that is called when an object is created. It is used to initialize the object's attributes. The self parameter is a reference to the object itself, and is used to access the object's attributes.`}
                        headerStyle='none'
                        headStyle='none'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='You can also define methods in a class, which are functions that are associated with a class. For example:'
                        headStyle='none'
                        code={`class Dog:\n\tdef __init__(self, name, breed):\n\t\tself.name = name\n\t\tself.breed = breed\n\n\tdef bark(self):\n\t\tprint("Woof!")\n\ndog1 = Dog("Fido", "Labrador")\ndog1.bark()  # Outputs "Woof!"`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des={`In this example, we have defined a bark method for the Dog class that simply prints "Woof!".`}
                        headerStyle='none'
                        headStyle='none'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        heading='Exception Handling'
                        des='In Python, you can use try-except blocks to handle exceptions, which are errors that occur during the execution of a program. The try block contains the code that may cause an exception, and the except block contains the code that handles the exception.'
                        headerStyle='none'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='For example:'
                        headStyle='none'
                        code={`try:\n  num1 = int(input("Enter a number: "))\n  num2 = int(input("Enter another number: "))\n  result = num1 / num2\n  print(result)\nexcept ZeroDivisionError:\n  print("Cannot divide by zero!")\nexcept ValueError:\n  print("Invalid input!")`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des={`In this example, we are trying to divide two numbers that are entered by the user. If the user enters an invalid value (such as a string instead of a number), a ValueError will be raised. If the user tries to divide by zero, a ZeroDivisionError will be raised. The except blocks handle these exceptions and print an appropriate message.`}
                        headerStyle='none'
                        headStyle='none'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        heading='Regular Expressions'
                        des='Regular expressions are a powerful tool for matching patterns in strings. In Python, you can use the re module to work with regular expressions.'
                        headerStyle='none'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des={`To use regular expressions in Python, you first need to import the re module using import re. Then, you can use the re.search() function to search for a pattern in a string. The re.search() function returns a match object if the pattern is found, or None if the pattern is not found.`}
                        headerStyle='none'
                        headStyle='none'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='For example:'
                        headStyle='none'
                        code={`import re\n\nstring = "Hello, world!"\npattern = r"world"\n\nmatch = re.search(pattern, string)\nif match:\n   print("Match found!")\nelse:\n   print("Match not found.")`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des={`This code will output Match found!.`}
                        headerStyle='none'
                        headStyle='none'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        // eslint-disable-next-line 
                        des={`You can use special characters in your regular expression patterns to match specific types of characters. For example, the . character matches any single character, the * character matches zero or more occurrences of the preceding character, and the \d character matches any digit.`}
                        headerStyle='none'
                        headStyle='none'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='For example:'
                        headStyle='none'
                        code={`import re\n\nstring = "123-456-7890"\npattern = r"\\d{3}-\\d{3}-\\d{4}"\n\nmatch = re.search(pattern, string)\nif match:\n   print("Match found!")\nelse:\n   print("Match not found.")`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des={`This code will output Match found!.`}
                        headerStyle='none'
                        headStyle='none'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des={`You can also use regular expressions to find and replace patterns in strings using the re.sub() function. The re.sub() function takes a pattern, a replacement string, and the string to search as arguments, and returns a new string with the pattern replaced.`}
                        headerStyle='none'
                        headStyle='none'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des='For example:'
                        headStyle='none'
                        code={`import re\n\n
                        string = "Hello, world!"\npattern = r"world"\nreplacement = "Python"\n\nnew_string = re.sub(pattern, replacement, string)\nprint(new_string)  # Outputs "Hello, Python!"`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        des={`This is just a brief overview of regular expressions in Python. There is much more to learn about regular expressions, including advanced features such as grouping and lookaheads. If you want to learn more about regular expressions, you can find more information in the Python documentation or online resources.`}
                        headerStyle='none'
                        headStyle='none'
                    />
                </div>
            </ProjectTemplate>
        </>
    )
}